import { useStorage } from '../../../../context/storage-context';
import { useStorageKey } from '../../../../context/use-storage-key';

// Stored email of the customer created in this step; the create flow writes it on success.
export function useStoredCustomerEmail() {
  const key = useStorageKey('tutorial');
  const [email, setEmail, clearEmail] = useStorage<string>(key('create-customer-email'));

  return { email, setEmail, clearEmail };
}
